import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import CenterProductsActions, { CenterProductsRedux, CenterProductsTypes } from '../Redux/CenterProductsRedux'

const CenterProductsCRUDObservable = createCRUDObservable({
  mainRedux: CenterProductsRedux,
  reduxPath: 'center_products', 
   dataHandlers: {
    get: response => response.data.data,
  },
})
export const CenterProductsObservers = Object.assign({}, CenterProductsCRUDObservable.observers, {})
export const CenterProductsEpic = combineEpics(
  CenterProductsCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CenterProductsObservable.js